import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { useI18N } from '../../context/I18NContext';
import { useTheme } from '@mui/material';
export default function OrderList(props) {
    const { t } = useI18N();
    const theme = useTheme();
    return (_jsx(_Fragment, { children: _jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary }, children: t('Je hebt geen bestellingen.') }) }));
}
